import { createMeta } from '@/data/meta/utils';

const image = '/img/asset/TFT_University_Showdown_SEO.jpg';
const keywords = '라이엇 게임즈 아마추어 리그, 라이엇 아마추어 리그, 레벨업 라이엇, 레벨업 TFT, 전략적팀전투 대학 리그, 전략적팀전투 대학 대회, TFT 대학 리그, TFT 대학 대회, TFT 아마추어 대회, TFT UNIVERSITY SHOWDOWN, TFT 유니버시티 쇼다운';

export default {
  tftUniversityShowdownHome: {
    title: '[TFT UNIVERSITY SHOWDOWN] 대회 신청',
    ...createMeta({
      title: '[TFT UNIVERSITY SHOWDOWN] 대회 신청',
      description: 'TFT UNIVERSITY SHOWDOWN에 참여해 보세요.',
      keywords,
      image,
    }),
  },
  newsFeed: {
    title: '[TFT UNIVERSITY SHOWDOWN] 공지/이벤트',
    ...createMeta({
      title: '[TFT UNIVERSITY SHOWDOWN] 공지/이벤트',
      description: '대회 관련 공지 및 이벤트 내용을 확인해 보세요.',
      keywords,
      image,
    }),
  },
};
